<template>
    <Slide :title="title" :subtitle="subtitle">
        <PhoneVerification @verified="emit('next-slide')"/>
    </Slide>
</template>

<script setup lang="ts">

import Slide from "@/components/slides/Slide.vue";
import PhoneVerification from "@/components/PhoneVerification.vue";
import {computed} from "vue";
import {useRegistrationStore} from "@/stores/registration.ts";

const registrationStore = useRegistrationStore();
const props = defineProps({
    title: {
        type: String,
        default: 'Please verify your phone number'
    },
    subtitle: {
        type: String,
        default: "You should receive a verification code shortly"
    }
});

const canContinue = computed(() => {
    return registrationStore.registeringCompany.phoneVerified;
});

const slidePayload = computed(() => {
    return {}
});

defineExpose({
    canContinue,
    slidePayload
});

const emit = defineEmits(['next-slide']);

</script>
